/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bebo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#cd0300" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M16.915 25.118h-1.266c-4.099 0-7.435-3.335-7.435-7.435V8.417a1.536 1.536 0 013.072 0v9.266a4.367 4.367 0 004.362 4.362h1.266c2.405 0 4.362-1.957 4.362-4.362s-1.957-4.362-4.362-4.362h-.897a1.536 1.536 0 010-3.072h.897c4.099 0 7.435 3.335 7.435 7.435s-3.335 7.435-7.435 7.435z"/>'
  }
})
